import React, { useEffect } from 'react';
import { initFacebookPixel } from '../facebookPixel';
import './ExplorePlan.css';
const ExplorePlan = () => {
  const items = [
    { title: 'Badminton Coaching', image: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/O2.png', link: 'https://badminton.coaching.machaxi.com/' },
    { title: 'Swimming Coaching ', image: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/O5.png', link: 'https://swimming.coaching.machaxi.com/' },
    { title: 'Parent Toddler', image: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/O3.png', link: 'https://toddler.machaxi.com/' },
  ];
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);
  return (
    <div className="explore-plan">
      <h2 className="explore-title">Other Plans</h2>
      <div>
      <div className="circles-container">
        {items.map((item, index) => (
          <div className="circle-item" key={index}>
            <a href={item.link} target="_blank" rel="noopener noreferrer" className="circle-link">
              <div className="circle">
                <img src={item.image} alt={item.title} />
              </div>
            </a>
          
            <h3>{item.title}</h3>
          
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default ExplorePlan;
